import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replaceNullWithText',
})
export class ReplaceNullWithTextPipe implements PipeTransform {
    transform(value: string | null, replaceText = '( dato non disponibile )'): string {
        if (value == null || value.trim() === '') {
            return replaceText;
        }

        return value;
    }
}
